import React from "react";
import { MESSAGE_CONFIG } from "../../../../../constents";
import Image from "./Image";
import Video from "./Video";
import { isSender } from "../../../../../utils/chat.utils";
import Attachment from "./Attachment";
const MediaMapper = (type) => {
    console.log(type);
    switch (type) {
        case MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_VIDEO:
        case MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_VIDEO_OTHER:
            return Video;
        case MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_IMAGE:
        case MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_IMAGE_OTHER:
            return Image;
        default:
            return Attachment;
    }
};
const Media = (props) => {
    const { message } = props;
    const MediaComponent = MediaMapper(message.type);
    const attributes = {
        className: 'media__container',
    };
    if (!isSender(message))
        attributes.className += ` receiver`;
    return (React.createElement("div", Object.assign({}, attributes),
        React.createElement(MediaComponent, { message: message })));
};
export default Media;
